
function BasicImageDescription( props )
{
    return (
        <div>
            <div style={{ marginBottom:'10px' }}>
                <b>Image</b>
            </div>
            <p>
                The image layer allows you to include an image or a gif in your widget. These images are static and serve 
                as the building block of your widget. Images can be used to give your widget a more unique feeling and add 
                personality to your widgets.
            </p>
        </div>
    )
}

function BasicTextDescription( props )
{
    return (
        <div>
            <div style={{ marginBottom:'10px' }}>
                <b>Text</b>
            </div>
            <p>
                The text layer allows you to display text within your widget. The following information can be displayed
                within the text layer : 
            </p>
            <ul>
                <li>
                    By presetting the value of the text layer, you can show static text in your widget. This is usefull when
                    you want to give some information to the viewers.
                </li>
                <li>
                    Using variables you can dynamically change the content of the text field to show the value of the variable 
                    set by other layers, widgets, or AI models.
                </li>
                <li>
                    In special cases where a variable points to a viewer id, the text field can either show the viewer id or the 
                    message sent by this viewer. 
                </li>
            </ul>
        </div>
    )
}

export default function Descriptions( props )
{
    const type = props.type 


    if( type == "basic-image" )
    {
        return <BasicImageDescription />
    }

    if( type == "basic-text" )
    {
        return <BasicTextDescription />
    }
    
    
    return (
        <div>
            <div style={{ marginBottom:'10px' }}>
                <b>No description is avaiable</b>
            </div>
        </div>
    )
}
